/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import PearsonLogoColor from '../../../public/images/logo_pearson_color.png';
import './PearsonLogo.style.scss';

const PearsonLogo = props => {
  const { isIconDisable } = props;
  const className = isIconDisable ? 'disabled-link' : '';
  return (
    <Link to="/" className={className} aria-label="pearson-logo">
      <img src={PearsonLogoColor} className="pearson-logo" alt="Pearson" />
    </Link>
  );
};

PearsonLogo.propTypes = {
  isIconDisable: PropTypes.bool
};

export default PearsonLogo;
